// extracted by mini-css-extract-plugin
export var surveySessionStateIndicator = "survey-session-state-indicator-module--survey-session-state-indicator--bcD0C";
export var text = "survey-session-state-indicator-module--text--lJM0s";